/**
 * Created by ljybill@aliyun.com  on 2018/7/2
 */
import Ajax from '../../ajax/index'

const app = {
  state: {
    userInfo: {},
    notice: {},
    fans: {},
    unReadNum: 0
  },
  mutations: {
    initUserInfo (state, data) {
      window.sessionStorage['userInfo'] = JSON.stringify(data)
      state.userInfo = data
    },
    logoutAcount (state) {
      window.sessionStorage['userInfo'] = ''
      state.userInfo = {}
    },
    setNotice (state, notice) {
      if (notice == null) {
        state.notice.messageNoReadCount = 0
      } else if (!isNaN(notice)) {
        if (state.notice)state.notice.messageNoReadCount = notice
      } else {
        state.notice = notice
      }
    },
    removeFans (state) {
      let tmpUserInfo = JSON.parse(window.sessionStorage['userInfo'])
      tmpUserInfo['newFansNum'] = 0
      window.sessionStorage['userInfo'] = JSON.stringify(tmpUserInfo)
      state.userInfo['newFansNum'] = 0
    },
    setUnReadNum (state, data) {
      state.unReadNum = data
    }
  },
  actions: {
    setUnReadNum (ctx, data) {
      ctx.commit('setUnReadNum', data)
    },
    getUserInfo (ctx, data) {
      return new Promise((resolve, reject) => {
        Ajax.getUserInfo(data).then((res) => {
          if (res.code === '0') {
            // 再获取专家详情
            Ajax.getExpertDetail({
              expertId: res.data.id
            }).then((expertDetail) => {
              let userInfo = {
                ...res.data,
                ...expertDetail.data
              }
              ctx.commit('initUserInfo', userInfo)
              resolve(userInfo)
            })
          } else {
            reject(res)
          }
        })
      })
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js